import styled from "styled-components";
import Colors from "constants/Colors";
import { QuicksandBold } from "components/Text";
import { Icon as IconRepgen } from "components";

export const LoadContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 28px;
`;

export const NewEnquiryButtons = styled.div`
  margin-top: 5px;
  width: 184px;
  min-height: 54px;
  border: 1px solid ${Colors.GRAY[1]};
  box-sizing: border-box;
  border-radius: 8px;
  margin-right: 15px;

 :hover{
    cursor: pointer;
  }
`;

export const HeaderContainer = styled.div`
margin-top: 30px;
border-radius: 20px 20px 0px 0px;
border: 1px solid ${Colors.SECONDARY};
background: ${Colors.SECONDARY};
padding: 10px 10px 0px 10px;
margin-bottom: 0px;

`;

export const CalendarContainer = styled.div`
  z-index: 55;
  top: 60px;
  right: 24px;

  position: absolute;
`;

export const Label = styled.label`
  ${QuicksandBold}
  font-size:12px;
  display: flex;
  align-self: center;
  line-height: 150%;
  cursor: pointer;
`;

export const Icon = styled(IconRepgen)`
  width: 41.2px;
  height: 44px;
  margin-left: 10px;
  margin-top: 5px;
`;